import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import * as _ from 'lodash';

@Component({
  selector: 'sortable-list',
  templateUrl: './sortable-list.component.html',
  styleUrls: ['./sortable-list.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SortableListComponent implements OnInit, AfterViewInit {

  constructor() {}

  @Input()
  displayValue = 'name';

  @Input()
  list: any;

  @Input()
  filteredList: any;

  @Input()
  itemId: number;

  @Output()
  listOrderChanged = new EventEmitter();

  selectedItem: any;
  displayedColumns = [this.displayValue];

  @ViewChild(VirtualScrollerComponent, {static: true})
  private virtualScroller: VirtualScrollerComponent;

  ngAfterViewInit(): void {
    this.scrollToView(this.list.indexOf(this.selectedItem));
  }

  ngOnInit(): void {
    this.selectedItem = this.filteredList ?
        this.getListIds(this.filteredList) : this.getListIds(this.list);
  }

  isUpAvailable(): boolean {
    return this.notFirst(this.selectedItem);
  }

  isDownAvailable(): boolean {
    return this.notLast(this.selectedItem);
  }

  moveUp(): void {
    const currentList = this.filteredList ? this.filteredList : this.list;
    const selectedIndex = currentList.indexOf(this.selectedItem);
    const tempItem = currentList[selectedIndex - 1];

    currentList[selectedIndex - 1] = this.selectedItem;
    currentList[selectedIndex] = tempItem;

    if (!_.isNil(this.filteredList)) {
      this.swapItemsLocation(tempItem);
    } else {
      this.onItemListChanged();
      this.scrollToView(this.list.indexOf(this.selectedItem));
    }
  }

  moveDown(): void {
    const currentList = this.filteredList ? this.filteredList : this.list;
    const selectedIndex = currentList.indexOf(this.selectedItem);
    const tempItem = currentList[selectedIndex + 1];

    currentList[selectedIndex + 1] = this.selectedItem;
    currentList[selectedIndex] = tempItem;

    if (!_.isNil(this.filteredList)) {
      this.swapItemsLocation(tempItem);
    } else {
      this.onItemListChanged();
      this.scrollToView(this.list.indexOf(this.selectedItem));
    }
  }

  moveBelow(item): void {
    if (item.id === this.selectedItem.id) {
      return;
    }

    const selectedItemIndex = this.list.indexOf(this.selectedItem);
    this.list.splice(selectedItemIndex, 1);

    const clickedItemIndex = this.list.indexOf(item);
    this.list.splice(clickedItemIndex, 0, this.selectedItem);
    this.onItemListChanged();
  }

  isSelected(item): boolean {
    if (_.isNil(this.selectedItem)) {
      return false;
    }
    return item.id === this.selectedItem.id;
  }

  onItemListChanged(): void {
    this.list = [...this.list];
    this.listOrderChanged.emit(this.filteredList ? this.filteredList : this.list);
  }

  scrollToView(index): void {
    const startIndex = this.virtualScroller.viewPortInfo.startIndex;
    const endIndex =  this.virtualScroller.viewPortInfo.endIndex;

    if (startIndex > index || index > endIndex) {
      this.virtualScroller.scrollToIndex(index);
    }
  }

  private getListIds(list): boolean {
    return list.find((item) => item.id === this.itemId);
  }

  private notLast(value): boolean {
    return (this.filteredList ? this.filteredList.indexOf(value) :
        this.list.indexOf(value)) < (this.filteredList ? this.filteredList.length - 1 : this.list.length - 1);
  }

  private notFirst(value): boolean {
    return (this.filteredList ? this.filteredList.indexOf(value) :
        this.list.indexOf(value)) > 0;
  }

  private findSelectedItemIndex(list, selectedItemId): number {
    return list.indexOf(this.list.find(item => {
      return item.id === selectedItemId;
    }));
  }

  private swapItemsLocation(target): void {
    this.onItemListChanged();
    this.scrollToView(this.filteredList.indexOf(this.selectedItem));

    const targetListItemIndex = this.findSelectedItemIndex(this.list, target.id);
    const currentListItemIndex = this.findSelectedItemIndex(this.list, this.selectedItem.id);

    const temp = this.list[targetListItemIndex];
    this.list[targetListItemIndex] = this.list[currentListItemIndex];
    this.list[currentListItemIndex] = temp;
  }
}
